
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26.563 19.163"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(.609 6.252)","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"2.765","cy":"2.765","r":"2.765","transform":"rotate(-77.025 4.61 1.156)"}}),_c('path',{attrs:{"d":"M0 10.65s.688-2.687 5.765-2.687a8.936 8.936 0 013.871.767"}})]),_c('g',{attrs:{"transform":"translate(6.686 .599)","fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"4.662","cy":"4.662","r":"4.662","transform":"rotate(-77.025 7.773 1.95)"}}),_c('path',{attrs:{"d":"M0 17.955s1.159-4.53 9.72-4.53 9.561 4.53 9.561 4.53"}})])])
          )
        }
      }
    